import React from 'react'
import ReusableModal from '../ReuseableModel'
import { Box, Button } from "@mui/material";
// For add the Alt and Title for image in Collage
const SeoModel = ({ openModel, closeModel, imgAltAttrib, setImgAltAttrib, imgTitleAttrib, setImgTitleAttrib, submitFun }) => {

  return (
    <>
      <ReusableModal
        open={openModel}
        handleClose={closeModel}
        title="SEO Attributes"
        content={
          <form onSubmit={submitFun}>
            <Box display="flex" flexDirection="column" gap={2}>
              <div className="flex flex-col items-start space-y-4 font-poppins">
                <label className="flex flex-col w-full">
                  <span className="mb-2">
                    Image Alt Attribute
                  </span>
                  <input
                    type="text"
                    name={`alt`}
                    value={imgAltAttrib}
                    className="p-2 border rounded-md focus:ring-1 focus:ring-blue-500 focus:outline-none"
                    onChange={(e) =>
                      setImgAltAttrib(e.target.value)
                    }
                  />
                </label>
              </div>
              <div className="flex flex-col items-start space-y-4 font-poppins">
                <label className="flex flex-col w-full">
                  <span className="mb-2">
                    Image Title Attribute
                  </span>
                  <input
                    type="text"
                    name={`alt`}
                    value={imgTitleAttrib}
                    className="p-2 border rounded-md focus:ring-1 focus:ring-blue-500 focus:outline-none"
                    onChange={(e) =>
                      setImgTitleAttrib(e.target.value)
                    }
                  />
                </label>
              </div>

              <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
                <Button onClick={closeModel} color="secondary" variant="outlined">
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Submit
                </Button>
              </Box>
            </Box>
          </form>
        }
      />
    </>
  )
}

export default SeoModel